import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Text from './text';

class ArticleDetail extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        className: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {}

    getContent = (itemData, index) => {
        if (itemData.type === 'text') {
            return <Text content={itemData.data} key={index} />;
        }

        return null;
    };

    render() {
        const {
            content: { contentList },
            className,
        } = this.props;

        return (
            <div className={className}>
                <div className="article-detail">
                    <div className="article-content">
                        {contentList.map((item, index) => {
                            return this.getContent(item, index);
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ArticleDetail);
